module.exports = __webpack_public_path__ + "img/bottom_menu_bg.ab63a81a.png";